import { AxiosResponse } from "axios";

import API from "../../api";

import { User } from "../../models/user";

const ROUTE_NAME = "route/drivers";

const RoutePlannerDriverService = {
  async create(fleet: User): Promise<AxiosResponse<User>> {
    return await API.post(`/${ROUTE_NAME}`, fleet);
  },
  async update(id: string, fleet: User): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, fleet);
  },
  async delete(id: number): Promise<AxiosResponse<User>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
};

export default RoutePlannerDriverService;
